module.exports = __webpack_public_path__ + "static/media/narayana.338249ff.png";